import React, { useState } from "react";

const EmergencyAdmission = ({ data, updateData }) => {
  const [formState, setFormState] = useState(data || {});

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedForm = { ...formState, [name]: value };
    setFormState(updatedForm);
    updateData(updatedForm);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Emergency Admission Data", formState);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label
            htmlFor="admissionType"
            className="block text-gray-700 font-medium"
          >
            Admission Type
          </label>
          <select
            id="admissionType"
            name="admissionType"
            value={formState.admissionType || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select admission type</option>
            <option value="ICU">ICU</option>
            <option value="Surgery">Surgery</option>
            <option value="Observation">Observation</option>
          </select>
        </div>
        <div>
          <label
            htmlFor="responsiblePhysician"
            className="block text-gray-700 font-medium"
          >
            Responsible Physician
          </label>
          <input
            type="text"
            id="responsiblePhysician"
            name="responsiblePhysician"
            value={formState.responsiblePhysician || ""}
            onChange={handleChange}
            placeholder="Enter responsible physician"
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label
            htmlFor="department"
            className="block text-gray-700 font-medium"
          >
            Department/Unit
          </label>
          <select
            id="department"
            name="department"
            value={formState.department || ""}
            onChange={handleChange}
            className="w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select department</option>
            <option value="Cardiology">Cardiology</option>
            <option value="Neurology">Neurology</option>
            <option value="General">General</option>
          </select>
        </div>
      </div>
      <button
        type="submit"
        className="px-4 py-2 bg-[#C7EAC9] text-black rounded-md"
      >
        Save & Next
      </button>
    </form>
  );
};

export default EmergencyAdmission;
